export const rules = function(self) {
  return {
    // 基本信息校验
    // beginTime: [{
    //   required: true,
    //   message: '请选择日期',
    //   trigger: ['change', 'blur'],
    // }],
    // endTime: [{
    //   required: true,
    //   message: '请选择时间',
    //   trigger: ['change', 'blur'],
    // }],
    // saleNo: [{
    //   required: true,
    //   message: '请选择业务员',
    //   trigger: ['change', 'blur'],
    // }],
    // accidentCount: [{ required: true, message: '请填写补偿次数', trigger: ['change', 'blur']}],
    // orgNo: [{
    //   required: true,
    //   message: '请选择出单公司',
    //   trigger: ['change', 'blur'],
    // }],
    // payType: [{
    //   required: true,
    //   message: '请选择支付方式',
    //   trigger: ['change', 'blur'],
    // }],
    // HandlerNo: [{
    //   required: true,
    //   message: '请选择经办人',
    //   trigger: ['change', 'blur'],
    // }],
    // 车辆校验
    // accidentType: [{
    //   required: true,
    //   message: '请填写历年状态',
    //   trigger: ['change', 'blur'],
    // }],
    // carNo: [{
    //   required: true,
    //   message: '请填写车辆信息',
    //   trigger: ['change', 'blur'],
    // }],
    // engineNo: [{
    //   required: true,
    //   message: '请填写发动机号',
    //   trigger: ['change', 'blur'],
    // }],
    // vin: [{
    //   required: true,
    //   message: '请选择车架号',
    //   trigger: ['change', 'blur'],
    // }],
    // usetype: [{
    //   required: true,
    //   message: '请填写使用性质',
    //   trigger: ['change', 'blur'],
    // }],
    // brandType: [{
    //   required: true,
    //   message: '请填写品牌型号',
    //   trigger: ['change', 'blur'],
    // }],
    // carType: [{
    //   required: true,
    //   message: '请填写车辆类型',
    //   trigger: ['change', 'blur'],
    // }],
    // passengerCount: [{
    //   required: true,
    //   message: '请填写荷载乘客',
    //   trigger: ['change', 'blur'],
    // }],
    // loadWeight: [{
    //   required: true,
    //   message: '请填写核载质量',
    //   trigger: ['change', 'blur'],
    // }],
    // newPrice: [{
    //   required: true,
    //   message: '请填写新车价',
    //   trigger: ['change', 'blur'],
    // }],
    
    // carClass: [{
    //   required: true,
    //   message: '请填写车辆种类',
    //   trigger: ['change', 'blur'],
    // }],
    // beginDate: [{
    //   required: true,
    //   message: '请选择初登日期',
    //   trigger: ['change', 'blur'],
    // }],
  }
}
 
export default {}